import React from 'react';
// import Cookies from 'js-cookie';
import { connect } from 'react-redux';
import {
	initHandler,
	ajaxViewHandler,
	ajaxHandler,
	setConfig,
} from "../../store/actions";
import {
	// Breadcrumb,
	// Card,
	Row,
	Col,
	// Input,
	// Button,
	// Table,
	// Modal,
	message,
	// Alert,
	// Select,
	// Tooltip,
	// Spin,
	// Form,
	// Skeleton
} from 'antd';

import moment from 'moment';

import Config from '../../Config';
import {Helmet} from "react-helmet";
import queryString from 'query-string';

import '../../assets/laporan.css';


const configClass = {
	title: 'LAPORAN CETAK STNK',
	apiUrl: {
		preview: 'laporan/api/cetak/stnk',
		userProfile: "auth/api/user/info"
	},

}

class LapCetakStnkCetak extends React.Component {
	config;
	
	constructor(props){
	    super(props);
	    this.config = new Config();
	    this.state = {
	    	loading: false,
	    	data: null,
	    	err: false,

	    	namauptppd: 'SAMSAT PALANGKARAYA',
	    }

	    // this.preview(this.props.match.params.id);
	    
	}

	componentDidMount(){
		var uri_params = "";
		const uri_string = queryString.parse(this.props.location.search);
		for (var key in uri_string) {
			if(uri_params == ""){
				uri_params = "?"+key+"="+uri_string[key];
			}else{
				uri_params += "&"+key+"="+uri_string[key];
			}
		}
		this.preview(uri_params);
	}

	async preview(uri_params) {
		message.loading({ content: 'Menampilkan laporan...', duration: 0, key: 'toast' });
		this.setState({
			loading: true,
			err: false,
			data: null,
		});

		this.props.ajaxViewHandler('get', configClass.apiUrl.preview+uri_params)
		.then(() =>{
			const data = this.props.responseMsg;
			if(this.props.isSuccess){
				message.destroy();
				this.setState({
					loading: false,
					data: data,
					err: false
				});
				setTimeout(function(){
					window.print();

				}, 1300);
	        }else{
	        	const errTitle = 'error get laporan';
	        	this.setState({
	        		loading: false,
	        		data: null,
	        		err: true,
	        		errMsg: this.props.responseMsg
	        	});
	        	message.error({ content: errTitle, duration: 2, key: 'toast' });
	        }
		}).catch((response) => {
			this.setState({
	        		loading: false,
	        		data: null,
	        		err: true,
	        		errMsg: 'unknown response'
	        });
			console.log('gagal_get_laporan', response);
			message.error({ content: 'gagal request data, coba lagi', duration: 2, key: 'toast' });
		});
	}

	render() {		
    	return (
			<>
			  	<Helmet>
			  		<title>{configClass.title}</title>
			  	</Helmet>
			  	<div className="kertas-laporan">
									  		<div className="judul-laporan teks-tengah">
									  			KEPOLISIAN NEGARA REPUBLIK INDONESIA<br />
													DIREKTORAT LALU LINTAS<br />
													DAERAH KALIMANTAN TENGAH
									  		</div>
									  		<table className="laporan-table" border="1" cellPadding="5">
									  			<thead>
									  				<tr>
									  					<th>No</th>
									  					<th>NO POLISI</th>
									  					<th>NAMA PEMILIK<br />ALAMAT PEMILIK</th>
									  					<th>JENIS KENDARAAN<br />MERK / MODEL</th>
									  					<th>TAHUN BUAT<br />WARNA KENDARAAN</th>
									  					<th>NO CHASIS<br />NO MESIN</th>
									  					<th>BAHAN BAKAR<br />PLAT NOMOR</th>
									  					<th>NO BPKB<br />NO STNK</th>
									  					<th>TANGGAL<br />AKHIR STNK</th>
									  				</tr>
									  			</thead>
									  			<tbody>
									  				{(this.state.data != null && this.state.data.map((item, id) => (
									  					<tr>
										  					<td className="teks-kanan">{id+1}</td>
										  					<td className="teks-tengah">{item.nomor_polisi}</td>
										  					<td>{item.nama_wp}</td>
										  					<td>{item.jenis_kendaraan}</td>
										  					<td className="teks-tengah">{item.thn_buat}</td>
										  					<td>{item.nomor_mesin}</td>
										  					<td>{item.bahan_bakar_nama}</td>
										  					<td>{item.no_bpkb}</td>
										  					<td>{item.sd_stnk != null ? item.sd_stnk : "-"}</td>
										  				</tr>
									  				)))}
									  			</tbody>
									  		</table>
									  		{(this.state.data != null && this.state.data.ttd != undefined &&
									  				<Row justify="space-between" style={{marginTop: 10}}>
									  					{(this.state.data.ttd.kiri != undefined &&
									  							<Col span={10} className="teks-tengah">
									  								MENGETAHUI<br />
													  				{this.state.data.ttd.kiri.jabatan}
													  				<div style={{marginTop: 50}}>
													  					<u>{this.state.data.ttd.kiri.nama}</u><br />
													  					NIP : {this.state.data.ttd.kiri.nip}
													  				</div>
													  			</Col>
									  					)}
									  					{(this.state.data.ttd.kanan != undefined &&
												  			<Col span={10} className="teks-tengah">
												  				{this.state.namauptppd}, {moment().format('DD-MM-YYYY')}<br />
												  				{this.state.data.ttd.kanan.jabatan}
												  				<div style={{marginTop: 50}}>
												  					<u>{this.state.data.ttd.kanan.nama}</u><br />
												  					NIP : {this.state.data.ttd.kanan.nip}
												  				</div>
												  			</Col>
											  			)}
											  		</Row>
									  		)}
									  	</div>
			</>
    	)
    }

}

const mapStateToProps = function(state) {
	return state.configReducers
}

export default connect(
		mapStateToProps,
		{
			initHandler,
			setConfig,
			ajaxViewHandler,
			ajaxHandler,
		}
	)(LapCetakStnkCetak);